interface Route {
  path: string;
  label: string;
}

interface RouteParams {
  [key: string]: string | number;
}

// Utility function to build path with parameters
export function buildPath(route: Route, params?: RouteParams): string {
  if (!params) return route.path;

  let path = route.path;
  Object.entries(params).forEach(([key, value]) => {
    path = path.replace(`:${key}`, String(value));
  });

  return path;
}

export const siteRoutes = {
  // Home
  home: {
    path: "/",
    label: "Home",
  } as Route,

  // Auth
  auth: {
    login: {
      path: "/login",
      label: "Login",
    } as Route,
    register: {
      path: "/register",
      label: "Register",
    } as Route,
  },

  // Error
  error: {
    notFound: {
      path: "/404",
      label: "404: Page Not Found",
    } as Route,
  },

  // Profile
  profile: {
    view: {
      path: "/profile",
      label: "Profile",
    } as Route,
    edit: {
      path: "/profile/edit",
      label: "Edit Profile",
    } as Route,
  },

  // Joblistings
  jobs: {
    overview: {
      path: "/jobs",
      label: "Find Jobs",
    } as Route,
    view: {
      path: "/jobs/:slug",
      label: "Job Details",
    } as Route,
    create: {
      path: "/jobs/create",
      label: "Create Job",
    } as Route,
    edit: {
      path: "/jobs/edit/:slug",
      label: "Edit Job",
    } as Route,
  },

  // Admin
  admin: {
    users: {
      overview: {
        path: "/admin/users",
        label: "Users",
      } as Route,
      view: {
        path: "/admin/user/:id",
        label: "User Details",
      },
    },
  },
};
